export const useNotificationHandler: typeof import('./useNotificationHandler').useNotificationHandler =
  () => undefined
